import { Flame } from "lucide-react";

const WORDS = [
  "Pljeskavica",
  "Ćevapi",
  "Karađorđeva",
  "Sveže meso",
  "20 priloga",
  "Since 2000",
  "Punjena vešalica",
  "Lepinja sa žara",
  "Glovo & Wolt dostava",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span
          className={`font-display font-bold uppercase text-2xl sm:text-4xl tracking-tight px-6 sm:px-10 whitespace-nowrap ${
            i % 3 === 0 ? "text-ember" : i % 3 === 1 ? "text-leafdark" : "text-chili"
          }`}
        >
          {w}
        </span>
        <Flame className={`w-5 h-5 sm:w-7 sm:h-7 shrink-0 ${i % 3 === 0 ? "text-chili" : i % 3 === 1 ? "text-ember" : "text-leaf"}`} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-ember/15 bg-paper2 py-6 sm:py-8 overflow-hidden"
  >
    <div className="flex animate-marquee w-max">
      <Row />
      <Row />
    </div>
  </div>
);
